// Export an array of topics for VA 1st Grade Math
const nc2ndMathQuizContent = [
 // NC 2nd Grade Math — Multiple Choice Quiz Content
// Each game has 5 questions, 4 answer options, one correct.
// Drag & Drop templates with two buckets are provided at the end (Even/Odd, etc.).


  // NC.2.OA.1 — Addition & Subtraction word problems
  {
    slug: "addingfun",
    title: "Adding Fun",
    gameType: "multipleChoice",
    placeholderStyle: { backgroundColor: "transparent" },
    placeholderImage: "",
    questions: [
      {
        question: "8 + 7 = ?",
        answers: [
          { text: "15", correct: true },
          { text: "14", correct: false },
          { text: "16", correct: false },
          { text: "13", correct: false }
        ]
      },
      {
        question: "Maria had 12 stickers and got 6 more. How many now?",
        answers: [
          { text: "18", correct: true },
          { text: "16", correct: false },
          { text: "20", correct: false },
          { text: "6", correct: false }
        ]
      },
      {
        question: "Which shows making a ten to add 9 + 6?",
        answers: [
          { text: "9 + 1 + 5 = 15", correct: true },
          { text: "9 + 6 = 12", correct: false },
          { text: "6 + 6 = 12", correct: false },
          { text: "10 + 10 = 20", correct: false }
        ]
      },
      {
        question: "Which sum is the same as 7 + 8?",
        answers: [
          { text: "7 + 3 + 5", correct: true },
          { text: "7 + 7", correct: false },
          { text: "8 + 1", correct: false },
          { text: "5 + 5", correct: false }
        ]
      },
      {
        question: "Which number makes 6 + __ = 14?",
        answers: [
          { text: "8", correct: true },
          { text: "6", correct: false },
          { text: "7", correct: false },
          { text: "9", correct: false }
        ]
      }
    ]
  },
  {
    slug: "takingaway",
    title: "Taking Away",
    gameType: "multipleChoice",
    placeholderStyle: { backgroundColor: "transparent" },
    placeholderImage: "",
    questions: [
      {
        question: "14 − 6 = ?",
        answers: [
          { text: "8", correct: true },
          { text: "7", correct: false },
          { text: "6", correct: false },
          { text: "10", correct: false }
        ]
      },
      {
        question: "There are 18 apples. 7 are eaten. How many left?",
        answers: [
          { text: "11", correct: true },
          { text: "10", correct: false },
          { text: "12", correct: false },
          { text: "9", correct: false }
        ]
      },
      {
        question: "Which shows using a ten to subtract 13 − 8?",
        answers: [
          { text: "13 − 3 − 5 = 5", correct: true },
          { text: "13 − 8 = 8", correct: false },
          { text: "8 − 3 = 6", correct: false },
          { text: "10 − 8 = 4", correct: false }
        ]
      },
      {
        question: "Which difference equals 20 − 9?",
        answers: [
          { text: "(20 − 10) + 1", correct: true },
          { text: "(20 − 5) + 5", correct: false },
          { text: "(9 − 9) + 9", correct: false },
          { text: "(10 − 9) + 5", correct: false }
        ]
      },
      {
        question: "What makes 17 − __ = 9?",
        answers: [
          { text: "8", correct: true },
          { text: "7", correct: false },
          { text: "9", correct: false },
          { text: "6", correct: false }
        ]
      }
    ]
  },

  // NC.2.OA.3 — Odd & Even
  {
    slug: "oddnumbers",
    title: "Odd Numbers",
    gameType: "multipleChoice",
    placeholderStyle: { backgroundColor: "transparent" },
    placeholderImage: "",
    questions: [
      {
        question: "Which number is odd?",
        answers: [
          { text: "17", correct: true },
          { text: "12", correct: false },
          { text: "20", correct: false },
          { text: "8", correct: false }
        ]
      },
      {
        question: "An odd number has how many left when paired?",
        answers: [
          { text: "1 left over", correct: true },
          { text: "0 left over", correct: false },
          { text: "2 left over", correct: false },
          { text: "It depends", correct: false }
        ]
      },
      {
        question: "Which shows 9 as an odd number?",
        answers: [
          { text: "4 pairs and 1 left", correct: true },
          { text: "5 pairs and 0 left", correct: false },
          { text: "3 pairs and 0 left", correct: false },
          { text: "2 pairs and 2 left", correct: false }
        ]
      },
      {
        question: "Which sum is odd?",
        answers: [
          { text: "7 + 6", correct: true },
          { text: "8 + 4", correct: false },
          { text: "10 + 2", correct: false },
          { text: "6 + 8", correct: false }
        ]
      },
      {
        question: "Odd or even: 31?",
        answers: [
          { text: "Odd", correct: true },
          { text: "Even", correct: false },
          { text: "Both", correct: false },
          { text: "Neither", correct: false }
        ]
      }
    ]
  },
  {
    slug: "evennumbers",
    title: "Even Numbers",
    gameType: "multipleChoice",
    placeholderStyle: { backgroundColor: "transparent" },
    placeholderImage: "",
    questions: [
      {
        question: "Which number is even?",
        answers: [
          { text: "10", correct: true },
          { text: "5", correct: false },
          { text: "13", correct: false },
          { text: "21", correct: false }
        ]
      },
      {
        question: "An even number has how many left when paired?",
        answers: [
          { text: "0 left over", correct: true },
          { text: "1 left over", correct: false },
          { text: "2 left over", correct: false },
          { text: "It depends", correct: false }
        ]
      },
      {
        question: "Which shows 14 as even?",
        answers: [
          { text: "7 pairs, 0 left", correct: true },
          { text: "6 pairs, 2 left", correct: false },
          { text: "5 pairs, 4 left", correct: false },
          { text: "4 pairs, 1 left", correct: false }
        ]
      },
      {
        question: "Which sum is even?",
        answers: [
          { text: "9 + 9", correct: true },
          { text: "7 + 4", correct: false },
          { text: "5 + 8", correct: false },
          { text: "3 + 6", correct: false }
        ]
      },
      {
        question: "Odd or even: 100?",
        answers: [
          { text: "Even", correct: true },
          { text: "Odd", correct: false },
          { text: "Both", correct: false },
          { text: "Neither", correct: false }
        ]
      }
    ]
  },

  // NC.2.NBT.1 — Place Value
  {
    slug: "placevalue",
    title: "Place Value",
    gameType: "multipleChoice",
    placeholderStyle: { backgroundColor: "transparent" },
    placeholderImage: "",
    questions: [
      {
        question: "In 347, the 4 shows how many?",
        answers: [
          { text: "4 tens", correct: true },
          { text: "4 ones", correct: false },
          { text: "4 hundreds", correct: false },
          { text: "4 thousands", correct: false }
        ]
      },
      {
        question: "What is the value of 6 in 682?",
        answers: [
          { text: "600", correct: true },
          { text: "60", correct: false },
          { text: "6", correct: false },
          { text: "6,000", correct: false }
        ]
      },
      {
        question: "Which shows 5 hundreds, 3 tens, 2 ones?",
        answers: [
          { text: "532", correct: true },
          { text: "523", correct: false },
          { text: "352", correct: false },
          { text: "235", correct: false }
        ]
      },
      {
        question: "Which is the same as 200 + 40 + 7?",
        answers: [
          { text: "247", correct: true },
          { text: "274", correct: false },
          { text: "427", correct: false },
          { text: "2470", correct: false }
        ]
      },
      {
        question: "How many tens are in 90?",
        answers: [
          { text: "9", correct: true },
          { text: "90", correct: false },
          { text: "10", correct: false },
          { text: "8", correct: false }
        ]
      }
    ]
  },

  // NC.2.NBT.2 — Counting by 5s/10s/100s
  {
    slug: "countby5s",
    title: "Count By 5's",
    gameType: "multipleChoice",
    placeholderStyle: { backgroundColor: "transparent" },
    placeholderImage: "",
    questions: [
      {
        question: "What comes next? 5, 10, 15, __",
        answers: [
          { text: "20", correct: true },
          { text: "18", correct: false },
          { text: "22", correct: false },
          { text: "25", correct: false }
        ]
      },
      {
        question: "Skip-count by 5s starting at 25",
        answers: [
          { text: "30, 35, 40", correct: true },
          { text: "26, 27, 28", correct: false },
          { text: "35, 45, 55", correct: false },
          { text: "20, 30, 50", correct: false }
        ]
      },
      {
        question: "Which number is in the 5s pattern?",
        answers: [
          { text: "45", correct: true },
          { text: "43", correct: false },
          { text: "44", correct: false },
          { text: "47", correct: false }
        ]
      },
      {
        question: "How many 5s make 35?",
        answers: [
          { text: "7", correct: true },
          { text: "6", correct: false },
          { text: "8", correct: false },
          { text: "5", correct: false }
        ]
      },
      {
        question: "Which set shows counting by 5s?",
        answers: [
          { text: "10, 15, 20", correct: true },
          { text: "11, 12, 13", correct: false },
          { text: "12, 18, 24", correct: false },
          { text: "2, 4, 6", correct: false }
        ]
      }
    ]
  },
  {
    slug: "countby10s",
    title: "Count By 10's",
    gameType: "multipleChoice",
    placeholderStyle: { backgroundColor: "transparent" },
    placeholderImage: "",
    questions: [
      {
        question: "What comes next? 30, 40, 50, __",
        answers: [
          { text: "60", correct: true },
          { text: "55", correct: false },
          { text: "70", correct: false },
          { text: "65", correct: false }
        ]
      },
      {
        question: "Skip-count by 10s from 90",
        answers: [
          { text: "100, 110, 120", correct: true },
          { text: "95, 96, 97", correct: false },
          { text: "80, 70, 60", correct: false },
          { text: "92, 93, 94", correct: false }
        ]
      },
      {
        question: "How many 10s make 100?",
        answers: [
          { text: "10", correct: true },
          { text: "5", correct: false },
          { text: "20", correct: false },
          { text: "8", correct: false }
        ]
      },
      {
        question: "Which number is in the 10s pattern?",
        answers: [
          { text: "130", correct: true },
          { text: "135", correct: false },
          { text: "128", correct: false },
          { text: "133", correct: false }
        ]
      },
      {
        question: "Which set shows counting by 10s?",
        answers: [
          { text: "20, 30, 40", correct: true },
          { text: "22, 24, 26", correct: false },
          { text: "21, 31, 41", correct: false },
          { text: "5, 15, 25", correct: false }
        ]
      }
    ]
  },
  {
    slug: "countby100s",
    title: "Count By 100's",
    gameType: "multipleChoice",
    placeholderStyle: { backgroundColor: "transparent" },
    placeholderImage: "",
    questions: [
      {
        question: "What comes next? 100, 200, 300, __",
        answers: [
          { text: "400", correct: true },
          { text: "350", correct: false },
          { text: "450", correct: false },
          { text: "500", correct: false }
        ]
      },
      {
        question: "Skip-count by 100s from 400",
        answers: [
          { text: "500, 600, 700", correct: true },
          { text: "410, 420, 430", correct: false },
          { text: "450, 550, 650", correct: false },
          { text: "300, 200, 100", correct: false }
        ]
      },
      {
        question: "How many hundreds in 900?",
        answers: [
          { text: "9", correct: true },
          { text: "10", correct: false },
          { text: "8", correct: false },
          { text: "7", correct: false }
        ]
      },
      {
        question: "Which number belongs: 200, 300, __, 500?",
        answers: [
          { text: "400", correct: true },
          { text: "350", correct: false },
          { text: "450", correct: false },
          { text: "250", correct: false }
        ]
      },
      {
        question: "Which shows counting by 100s?",
        answers: [
          { text: "0, 100, 200", correct: true },
          { text: "90, 100, 110", correct: false },
          { text: "10, 20, 40", correct: false },
          { text: "5, 15, 25", correct: false }
        ]
      }
    ]
  },

  // NC.2.NBT.3 — Read & Write numbers to 1000 (expanded form)
  {
    slug: "expandedform",
    title: "Expanded Form",
    gameType: "multipleChoice",
    placeholderStyle: { backgroundColor: "transparent" },
    placeholderImage: "",
    questions: [
      {
        question: "Which is 305 in expanded form?",
        answers: [
          { text: "300 + 0 + 5", correct: true },
          { text: "30 + 5", correct: false },
          { text: "3 + 5", correct: false },
          { text: "300 + 50 + 5", correct: false }
        ]
      },
      {
        question: "Write 420 in expanded form",
        answers: [
          { text: "400 + 20 + 0", correct: true },
          { text: "40 + 2", correct: false },
          { text: "4 + 2 + 0", correct: false },
          { text: "402 + 0", correct: false }
        ]
      },
      {
        question: "Which number matches 200 + 70 + 1?",
        answers: [
          { text: "271", correct: true },
          { text: "217", correct: false },
          { text: "721", correct: false },
          { text: "127", correct: false }
        ]
      },
      {
        question: "Which is the same as 608?",
        answers: [
          { text: "600 + 0 + 8", correct: true },
          { text: "60 + 8", correct: false },
          { text: "600 + 80", correct: false },
          { text: "60 + 80", correct: false }
        ]
      },
      {
        question: "Standard form of 300 + 40 + 9",
        answers: [
          { text: "349", correct: true },
          { text: "394", correct: false },
          { text: "439", correct: false },
          { text: "943", correct: false }
        ]
      }
    ]
  },

  // NC.2.NBT.4 — Compare numbers
  {
    slug: "greaterthan",
    title: "Greater Than",
    gameType: "multipleChoice",
    placeholderStyle: { backgroundColor: "transparent" },
    placeholderImage: "",
    questions: [
      {
        question: "Which is greater: 482 or 429?",
        answers: [
          { text: "482", correct: true },
          { text: "429", correct: false },
          { text: "They are equal", correct: false },
          { text: "42", correct: false }
        ]
      },
      {
        question: "Which sign makes 376 __ 367 true?",
        answers: [
          { text: ">", correct: true },
          { text: "<", correct: false },
          { text: "=", correct: false },
          { text: ">=", correct: false }
        ]
      },
      {
        question: "Which is smallest?",
        answers: [
          { text: "205", correct: true },
          { text: "250", correct: false },
          { text: "502", correct: false },
          { text: "520", correct: false }
        ]
      },
      {
        question: "Which compares 740 and 704 correctly?",
        answers: [
          { text: "740 > 704", correct: true },
          { text: "740 < 704", correct: false },
          { text: "740 = 704", correct: false },
          { text: "704 > 740", correct: false }
        ]
      },
      {
        question: "Order from least to greatest: 312, 132, 231",
        answers: [
          { text: "132, 231, 312", correct: true },
          { text: "231, 132, 312", correct: false },
          { text: "312, 231, 132", correct: false },
          { text: "132, 312, 231", correct: false }
        ]
      }
    ]
  },

  // NC.2.NBT.5 — Add within 100 using strategies
  {
    slug: "addingproperties",
    title: "Adding Properties",
    gameType: "multipleChoice",
    placeholderStyle: { backgroundColor: "transparent" },
    placeholderImage: "",
    questions: [
      {
        question: "Which shows the Commutative Property?",
        answers: [
          { text: "8 + 5 = 5 + 8", correct: true },
          { text: "8 + 0 = 8", correct: false },
          { text: "(2 + 3) + 4 = 2 + (3 + 4)", correct: false },
          { text: "5 + 5 = 10", correct: false }
        ]
      },
      {
        question: "Which shows the Associative Property?",
        answers: [
          { text: "(2 + 3) + 4 = 2 + (3 + 4)", correct: true },
          { text: "7 + 1 = 1 + 7", correct: false },
          { text: "9 + 0 = 9", correct: false },
          { text: "10 + 10 = 20", correct: false }
        ]
      },
      {
        question: "Which helps add 27 + 5 quickly?",
        answers: [
          { text: "27 + 3 + 2 = 32", correct: true },
          { text: "27 + 5 = 25", correct: false },
          { text: "27 + 7 = 34", correct: false },
          { text: "20 + 5 = 24", correct: false }
        ]
      },
      {
        question: "Which is a true addition fact?",
        answers: [
          { text: "36 + 4 = 40", correct: true },
          { text: "36 + 4 = 30", correct: false },
          { text: "14 + 6 = 25", correct: false },
          { text: "9 + 9 = 17", correct: false }
        ]
      },
      {
        question: "Which equals 43 + 20?",
        answers: [
          { text: "63", correct: true },
          { text: "53", correct: false },
          { text: "60", correct: false },
          { text: "23", correct: false }
        ]
      }
    ]
  },

  // NC.2.NBT.6 — Add up to four two-digit numbers
  {
    slug: "add3digits",
    title: "Add 3 Digits",
    gameType: "multipleChoice",
    placeholderStyle: { backgroundColor: "transparent" },
    placeholderImage: "",
    questions: [
      {
        question: "35 + 22 + 10 = ?",
        answers: [
          { text: "67", correct: true },
          { text: "57", correct: false },
          { text: "77", correct: false },
          { text: "65", correct: false }
        ]
      },
      {
        question: "14 + 16 + 20 = ?",
        answers: [
          { text: "50", correct: true },
          { text: "40", correct: false },
          { text: "60", correct: false },
          { text: "46", correct: false }
        ]
      },
      {
        question: "9 + 12 + 18 = ?",
        answers: [
          { text: "39", correct: true },
          { text: "29", correct: false },
          { text: "41", correct: false },
          { text: "30", correct: false }
        ]
      },
      {
        question: "20 + 20 + 20 = ?",
        answers: [
          { text: "60", correct: true },
          { text: "50", correct: false },
          { text: "70", correct: false },
          { text: "40", correct: false }
        ]
      },
      {
        question: "15 + 25 + 10 = ?",
        answers: [
          { text: "50", correct: true },
          { text: "40", correct: false },
          { text: "55", correct: false },
          { text: "60", correct: false }
        ]
      }
    ]
  },

  // NC.2.NBT.8 — Mental addition/subtraction of 10 or 100
  {
    slug: "addby10s",
    title: "Add By 10's",
    gameType: "multipleChoice",
    placeholderStyle: { backgroundColor: "transparent" },
    placeholderImage: "",
    questions: [
      {
        question: "54 + 10 = ?",
        answers: [
          { text: "64", correct: true },
          { text: "65", correct: false },
          { text: "74", correct: false },
          { text: "44", correct: false }
        ]
      },
      {
        question: "90 − 10 = ?",
        answers: [
          { text: "80", correct: true },
          { text: "70", correct: false },
          { text: "85", correct: false },
          { text: "60", correct: false }
        ]
      },
      {
        question: "203 + 100 = ?",
        answers: [
          { text: "303", correct: true },
          { text: "213", correct: false },
          { text: "2030", correct: false },
          { text: "293", correct: false }
        ]
      },
      {
        question: "420 − 100 = ?",
        answers: [
          { text: "320", correct: true },
          { text: "400", correct: false },
          { text: "220", correct: false },
          { text: "300", correct: false }
        ]
      },
      {
        question: "Which shows +10?",
        answers: [
          { text: "67 → 77", correct: true },
          { text: "67 → 76", correct: false },
          { text: "67 → 87", correct: false },
          { text: "67 → 70", correct: false }
        ]
      }
    ]
  },

  // NC.2.MD.1 — Measure with rulers (inches/centimeters)
  {
    slug: "englishruler",
    title: "English Ruler",
    gameType: "multipleChoice",
    placeholderStyle: { backgroundColor: "transparent" },
    placeholderImage: "",
    questions: [
      {
        question: "Which unit is on an English ruler?",
        answers: [
          { text: "Inches", correct: true },
          { text: "Centimeters", correct: false },
          { text: "Meters", correct: false },
          { text: "Liters", correct: false }
        ]
      },
      {
        question: "About how long is a paperclip?",
        answers: [
          { text: "1 inch", correct: true },
          { text: "1 foot", correct: false },
          { text: "10 inches", correct: false },
          { text: "1 yard", correct: false }
        ]
      },
      {
        question: "12 inches equals what?",
        answers: [
          { text: "1 foot", correct: true },
          { text: "1 yard", correct: false },
          { text: "1 mile", correct: false },
          { text: "1 centimeter", correct: false }
        ]
      },
      {
        question: "Which is longer?",
        answers: [
          { text: "1 foot", correct: true },
          { text: "10 inches", correct: false },
          { text: "8 inches", correct: false },
          { text: "6 inches", correct: false }
        ]
      },
      {
        question: "About how long is a crayon?",
        answers: [
          { text: "3 inches", correct: true },
          { text: "3 feet", correct: false },
          { text: "30 inches", correct: false },
          { text: "1 yard", correct: false }
        ]
      }
    ]
  },
  {
    slug: "metricruler",
    title: "Metric Ruler",
    gameType: "multipleChoice",
    placeholderStyle: { backgroundColor: "transparent" },
    placeholderImage: "",
    questions: [
      {
        question: "Which unit is on a metric ruler?",
        answers: [
          { text: "Centimeters", correct: true },
          { text: "Inches", correct: false },
          { text: "Feet", correct: false },
          { text: "Yards", correct: false }
        ]
      },
      {
        question: "About how long is a pencil?",
        answers: [
          { text: "15 centimeters", correct: true },
          { text: "15 inches", correct: false },
          { text: "1 meter", correct: false },
          { text: "150 centimeters", correct: false }
        ]
      },
      {
        question: "100 centimeters equals what?",
        answers: [
          { text: "1 meter", correct: true },
          { text: "10 meters", correct: false },
          { text: "1 kilometer", correct: false },
          { text: "10 centimeters", correct: false }
        ]
      },
      {
        question: "Which is shorter?",
        answers: [
          { text: "5 cm", correct: true },
          { text: "50 cm", correct: false },
          { text: "500 cm", correct: false },
          { text: "5 m", correct: false }
        ]
      },
      {
        question: "A book is about 25 __ long.",
        answers: [
          { text: "centimeters", correct: true },
          { text: "inches", correct: false },
          { text: "feet", correct: false },
          { text: "yards", correct: false }
        ]
      }
    ]
  },

  // NC.2.MD.7 — Tell and write time to 5 minutes
  {
    slug: "tellingtime",
    title: "Telling time",
    gameType: "multipleChoice",
    placeholderStyle: { backgroundColor: "transparent" },
    placeholderImage: "",
    questions: [
      {
        question: "If the minute hand is on 6, how many minutes?",
        answers: [
          { text: "30 minutes", correct: true },
          { text: "15 minutes", correct: false },
          { text: "5 minutes", correct: false },
          { text: "60 minutes", correct: false }
        ]
      },
      {
        question: "3:15 is read as what?",
        answers: [
          { text: "Three fifteen", correct: true },
          { text: "Three fifty", correct: false },
          { text: "Three o'clock", correct: false },
          { text: "Quarter to three", correct: false }
        ]
      },
      {
        question: "What time is 20 minutes after 4:00?",
        answers: [
          { text: "4:20", correct: true },
          { text: "4:50", correct: false },
          { text: "5:20", correct: false },
          { text: "4:12", correct: false }
        ]
      },
      {
        question: "If it is 7:55, 5 minutes later is?",
        answers: [
          { text: "8:00", correct: true },
          { text: "7:50", correct: false },
          { text: "7:00", correct: false },
          { text: "8:05", correct: false }
        ]
      },
      {
        question: "When the hour hand is between 2 and 3, the hour is?",
        answers: [
          { text: "2", correct: true },
          { text: "3", correct: false },
          { text: "2:30", correct: false },
          { text: "2:00", correct: false }
        ]
      }
    ]
  },

  // NC.2.MD.8 — Money
  {
    slug: "dollarscents",
    title: "Dollars & Cents",
    gameType: "multipleChoice",
    placeholderStyle: { backgroundColor: "transparent" },
    placeholderImage: "",
    questions: [
      {
        question: "How many cents in a quarter?",
        answers: [
          { text: "25¢", correct: true },
          { text: "10¢", correct: false },
          { text: "5¢", correct: false },
          { text: "50¢", correct: false }
        ]
      },
      {
        question: "Which equals 35¢?",
        answers: [
          { text: "1 quarter and 1 dime", correct: true },
          { text: "3 dimes", correct: false },
          { text: "1 quarter and 1 nickel and 1 penny", correct: false },
          { text: "2 quarters", correct: false }
        ]
      },
      {
        question: "$1.00 equals how many cents?",
        answers: [
          { text: "100¢", correct: true },
          { text: "50¢", correct: false },
          { text: "10¢", correct: false },
          { text: "25¢", correct: false }
        ]
      },
      {
        question: "You have 2 quarters and 1 dime. How much?",
        answers: [
          { text: "60¢", correct: true },
          { text: "50¢", correct: false },
          { text: "70¢", correct: false },
          { text: "40¢", correct: false }
        ]
      },
      {
        question: "Which shows the same amount of money?",
        answers: [
          { text: "5 nickels = 1 quarter", correct: true },
          { text: "2 dimes = 1 quarter", correct: false },
          { text: "10 pennies = 2 dimes", correct: false },
          { text: "1 quarter = 30¢", correct: false }
        ]
      }
    ]
  },

  // NC.2.MD.10 — Bar & Picture Graphs
  {
    slug: "bargraph",
    title: "Bargraph",
    gameType: "multipleChoice",
    placeholderStyle: { backgroundColor: "transparent" },
    placeholderImage: "",
    questions: [
      {
        question: "A bar shows 8 cats and 5 dogs. How many animals?",
        answers: [
          { text: "13", correct: true },
          { text: "12", correct: false },
          { text: "10", correct: false },
          { text: "15", correct: false }
        ]
      },
      {
        question: "Which has more on the graph: birds(6) or fish(9)?",
        answers: [
          { text: "Fish", correct: true },
          { text: "Birds", correct: false },
          { text: "Same", correct: false },
          { text: "None", correct: false }
        ]
      },
      {
        question: "If each square = 2 kids, 4 squares means?",
        answers: [
          { text: "8 kids", correct: true },
          { text: "6 kids", correct: false },
          { text: "4 kids", correct: false },
          { text: "10 kids", correct: false }
        ]
      },
      {
        question: "Cats(7) and dogs(4): how many more cats?",
        answers: [
          { text: "3", correct: true },
          { text: "2", correct: false },
          { text: "1", correct: false },
          { text: "4", correct: false }
        ]
      },
      {
        question: "Bars: red(5), blue(5), green(3). Which is least?",
        answers: [
          { text: "Green", correct: true },
          { text: "Red", correct: false },
          { text: "Blue", correct: false },
          { text: "Red and Blue", correct: false }
        ]
      }
    ]
  },
  {
    slug: "pictograph",
    title: "Pictograph",
    gameType: "multipleChoice",
    placeholderStyle: { backgroundColor: "transparent" },
    placeholderImage: "",
    questions: [
      {
        question: "If each picture = 2 votes, 5 pictures mean?",
        answers: [
          { text: "10 votes", correct: true },
          { text: "5 votes", correct: false },
          { text: "8 votes", correct: false },
          { text: "12 votes", correct: false }
        ]
      },
      {
        question: "Smiles(6 pics) vs stars(4 pics): which more?",
        answers: [
          { text: "Smiles", correct: true },
          { text: "Stars", correct: false },
          { text: "Same", correct: false },
          { text: "None", correct: false }
        ]
      },
      {
        question: "Hearts(3 pics) if each = 2, total?",
        answers: [
          { text: "6", correct: true },
          { text: "3", correct: false },
          { text: "9", correct: false },
          { text: "5", correct: false }
        ]
      },
      {
        question: "Circles(7) and squares(5): how many more circles?",
        answers: [
          { text: "2", correct: true },
          { text: "1", correct: false },
          { text: "3", correct: false },
          { text: "4", correct: false }
        ]
      },
      {
        question: "Triangles(4) stars(4): what does the graph show?",
        answers: [
          { text: "They are equal", correct: true },
          { text: "Triangles are more", correct: false },
          { text: "Stars are more", correct: false },
          { text: "No data", correct: false }
        ]
      }
    ]
  },

  // NC.2.G.1 — Triangles & Quadrilaterals
  {
    slug: "triangles",
    title: "Triangles",
    gameType: "multipleChoice",
    placeholderStyle: { backgroundColor: "transparent" },
    placeholderImage: "",
    questions: [
      {
        question: "A triangle has how many sides?",
        answers: [
          { text: "3", correct: true },
          { text: "4", correct: false },
          { text: "5", correct: false },
          { text: "6", correct: false }
        ]
      },
      {
        question: "Which shape is a triangle?",
        answers: [
          { text: "Shape with 3 corners", correct: true },
          { text: "Shape with 4 corners", correct: false },
          { text: "Round shape", correct: false },
          { text: "Shape with 2 sides", correct: false }
        ]
      },
      {
        question: "Which is NOT a triangle?",
        answers: [
          { text: "Square", correct: true },
          { text: "Three-sided sign", correct: false },
          { text: "Pointy slice", correct: false },
          { text: "Roof shape with 3 sides", correct: false }
        ]
      },
      {
        question: "All triangles have:",
        answers: [
          { text: "3 sides and 3 angles", correct: true },
          { text: "4 sides", correct: false },
          { text: "No corners", correct: false },
          { text: "Curved sides", correct: false }
        ]
      },
      {
        question: "Which picture could be a triangle?",
        answers: [
          { text: "Road sign with 3 sides", correct: true },
          { text: "Window with 4 sides", correct: false },
          { text: "Circle clock", correct: false },
          { text: "Ball", correct: false }
        ]
      }
    ]
  },
  {
    slug: "circles",
  title: "Circles",
  gameType: "multipleChoice",
  placeholderStyle: { backgroundColor: "transparent" },
  placeholderImage: "",
  questions: [
      {
        question: "How many sides does a circle have?",
        answers: [
          { text: "0", correct: true },
          { text: "1", correct: false },
          { text: "2", correct: false },
          { text: "4", correct: false }
        ]
      },
      {
        question: "What is the line across the center of a circle called?",
        answers: [
          { text: "Diameter", correct: true },
          { text: "Radius", correct: false },
          { text: "Chord", correct: false },
          { text: "Circumference", correct: false }
        ]
      },
      {
        question: "What do you call the distance around a circle?",
      answers: [
        { text: "Circumference", correct: true },
        { text: "Area", correct: false },
        { text: "Diameter", correct: false },
        { text: "Radius", correct: false }
        ]
      },
      {
        question: "What is the line from the center of a circle to its edge?",
      answers: [
        { text: "Radius", correct: true },
        { text: "Diameter", correct: false },
        { text: "Chord", correct: false },
        { text: "Arc", correct: false }
        ]
      },
      {
        question: "Which object is shaped like a circle?",
      answers: [
        { text: "A coin", correct: true },
        { text: "A square window", correct: false },
        { text: "A triangle sign", correct: false },
        { text: "A cube", correct: false }
        ]
      },
    ]
  }
];

// Two-bucket Drag & Drop templates (use as needed by your dragDrop engine)
// Each item has: question, buckets, items. Drag each item to one of two buckets.
// const nc2ndMathDragDropTemplates = [
  //{
    //  slug: "even-odd-sort",
    // title: "Even vs Odd",
    // buckets: ["Even", "Odd"],
    // items: ["10", "5", "14", "21", "32", "9", "0", "1"]
  // },
 //  {
  //  slug: "greater-less",
  //  title: "Greater vs Less (than 50)",
  //  buckets: ["> 50", "< 50"],
  //  items: ["72", "18", "50", "39", "84", "7", "63", "22"]
  // },
 // {
  //  slug: "dollars-cents",
  //  title: "Dollars vs Cents",
  //  buckets: ["Dollars", "Cents"],
  //  items: ["$1.00", "$5.00", "25¢", "10¢", "$10.00", "1¢", "50¢", "$2.00"]
  // },
 // {
  //  slug: "triangles-not",
 //   title: "Triangle or Not",
 //   buckets: ["Triangle", "Not a Triangle"],
 //   items: ["3 sides", "4 sides", "3 angles", "Circle", "3 corners", "Square"]
 // },
 // {
  //  slug: "quads-not",
  //  title: "Quadrilateral or Not",
  //  buckets: ["Quadrilateral", "Not a Quadrilateral"],
 //   items: ["4 sides", "3 sides", "Rectangle", "Triangle", "Square", "Pentagon"]
 // }
// ];
// export { nc2ndMathQuizContent, nc2ndMathDragDropTemplates };




export default nc2ndMathQuizContent;
